export const UNDEFINED_VALUE = 'undefined';
export const NULLABLE_VALUE = 'null';
